import { styled } from "goober";

export const ShortcutHint = styled("span")`
  font-size: 10px;
  color: var(--text-secondary);
`;
